import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const BreadcrumbNavigation = ({ currentSection = 'API Documentation Hub' }) => {
  const breadcrumbs = [
    { label: 'Home', path: '/' },
    { label: 'Documentation', path: '/api-documentation-hub' },
    { label: currentSection, path: null }
  ];

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6">
      {breadcrumbs?.map((crumb, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <Icon name="ChevronRight" size={14} className="text-muted-foreground" />
          )}
          {crumb?.path ? (
            <Link
              to={crumb?.path}
              className="hover:text-foreground transition-colors"
            >
              {crumb?.label}
            </Link>
          ) : (
            <span className="text-foreground font-medium">{crumb?.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default BreadcrumbNavigation;